module.exports = __webpack_public_path__ + "static/kismetSunset@fiferries.e6fd678c.jpg";